import { useEffect, useState } from "react";

import Cookies from "js-cookie";

const disableDevTools = Cookies.get("disableDevTools") == "true";
const REACT_APP_DISABLE_DEVTOOLS = process.env.REACT_APP_DISABLE_DEVTOOLS === 'true';

const useDetectDevTools = () => {
    const [devToolsOpen, setDevToolsOpen] = useState(false);

    return devToolsOpen;
};

export default useDetectDevTools;
